import { render, staticRenderFns } from "./EditPackagingModal.vue?vue&type=template&id=5ef351ef&scoped=true&"
import script from "./EditPackagingModal.vue?vue&type=script&lang=js&"
export * from "./EditPackagingModal.vue?vue&type=script&lang=js&"
import style0 from "./EditPackagingModal.vue?vue&type=style&index=0&id=5ef351ef&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ef351ef",
  null
  
)

export default component.exports